import React from "react";

import { LoaderStyled } from "./Loader.styles";

const Loader = (props) => {
    return (
        <LoaderStyled {...props} />
    );
};

export default Loader;